<div class="flex flex-col w-full h-full p-6 gap-6 bg-[#FEFCE840] overflow-auto">

  <create-template-timeline [currentStep]="currentStep()"></create-template-timeline>

  @if (loaded()) {
    @if (currentStep() === CreateTaStepType.REVIEW) {
      <create-template-review></create-template-review>
    } @else {
      <div class="w-full flex justify-between items-center pl-1">
        <div class="justify-start text-surface-800 text-lg font-medium font-['Inter']">{{ currentSubtitle() }}</div>
        <div class="flex gap-4">
          @if (currentIndex() > 0) {
            <p-button data-testid="template-back" (click)="goBack()"><i class="fa-regular fa-chevron-left"></i>{{'Back'}}</p-button>
          }
          <p-button data-testid="template-save-continue" (click)="saveAndContinue()" [disabled]="!canContinue()">{{'Save and Continue'}}<i class="fa-regular fa-chevron-right"></i></p-button>
        </div>
      </div>

      @switch (currentStep()) {
        @case (CreateTaStepType.TRAVELLERS) {
          <create-template-travellers></create-template-travellers>
        }
        @case (CreateTaStepType.DETAILS) {
          <create-template-details></create-template-details>
        }
        @case (CreateTaStepType.ITINERARY) {
          <create-template-itinerary></create-template-itinerary>
        }
      }
    }
  } @else {
    <div class="text-surface-500 text-sm font-['Inter']">Loading template...</div>
  }
</div>
